import KitCard from "./KitCard";

export default KitCard;
